import React from "react";
import {
  SEO,
  PageLayout,
  OutboundLink,
  ImageCollection,
  HoursOfOperation,
  Map,
} from "@bluefin/components";
import { Embed, Grid, Button, Image } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout hero={null} subfooter={false} className={"home-page"}>
          <div className={"home-hero-video-container"}>
            <div className={"hero-overlay"} />
            <Embed
              url={"https://player.vimeo.com/video/1157598320?background=1"}
              autoplay={true}
              className={"home-hero-video"}
              active={true}
              defaultActive={true}
            />
            <div className={"hero-content"} />
          </div>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={14} textAlign={"center"}>
              <Button
                as={OutboundLink}
                to={"https://order.toasttab.com/online/honeydipfingerz"}
                primary={true}
              >
                Order Online
              </Button>
              <Grid
                stackable={true}
                className={"component-section-container custom-banner"}
                verticalAlign={"top"}
                textAlign={"center"}
                columns={"equal"}
              >
                <Grid.Row streched={true}>
                  <Grid.Column>
                    <Image
                      size={"mini"}
                      centered={true}
                      src={
                        "https://fisherman.gumlet.io/public/honeydipfingerzllc/Honey_Dip_Fingerz__-_Order_Online.png"
                      }
                    />
                    <h4>ORDER YOUR FOOD</h4>
                    <p>
                      Skip the phone by ordering our mouth-watering dishes
                      online, browse through our menu now.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <Image
                      size={"mini"}
                      centered={true}
                      src={
                        "https://fisherman.gumlet.io/public/honeydipfingerzllc/Honey_Dip_Fingerz_-_Pickup.png"
                      }
                    />
                    <h4>PICKUP YOUR ORDER</h4>
                    <p>
                      Pick up your order when it is ready, or call for more
                      delivery options.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <Image
                      size={"mini"}
                      centered={true}
                      src={
                        "https://fisherman.gumlet.io/public/honeydipfingerzllc/Honey_Dip_Fingerz_-_Reviews.png"
                      }
                    />
                    <h4>WE LOVE YOUR FEEDBACK</h4>
                    <p>
                      Love your food? let us know how we did and how we can
                      serve you better.
                    </p>
                    <Button
                      primary={true}
                      size={"medium"}
                      className={"leave-review-cta"}
                      to={"https://g.page/r/CdPgRUr5IgBuEBM/review"}
                      as={OutboundLink}
                    >
                      Leave a Review
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={14} textAlign={"center"}>
              <Grid
                stackable={true}
                className={"about-section"}
                verticalAlign={"top"}
                textAlign={"center"}
                columns={2}
              >
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={8}
                  largeScreen={4}
                  textAlign={"left"}
                >
                  <p className={"tagline"}>
                    Honey-Dip Fingerz is a premier take-out Restaurant located
                    in McKinney Texas. We specialize in creating bespoke
                    Nigerian dishes to match your luxurious taste, budget and
                    delivery preferences. We are committed to providing you with
                    deluxe Nigerian dishes, carefully prepared with the highest
                    quality ingredients and served with a smile.
                  </p>
                </Grid.Column>
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={10}
                  largeScreen={12}
                >
                  <ImageCollection
                    images={[
                      "https://fisherman.gumlet.io/public/honeydipfingerzllc/Grand_Opening_1.jpg",
                      "https://fisherman.gumlet.io/public/honeydipfingerzllc/Grand_Opening_2.jpg",
                      "https://fisherman.gumlet.io/public/honeydipfingerzllc/Grand_Opening_3.jpg",
                      "https://fisherman.gumlet.io/public/honeydipfingerzllc/Grand_Opening_4.jpg",
                    ]}
                    as={"gallery"}
                    centered={true}
                    cutUnevenRows={true}
                    smartImageGrouping={false}
                    disable={"none"}
                    header={""}
                    numberOfRowDisplayItems={2}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
          <Grid.Column width={14} textAlign={"center"}>
            <Grid
              stackable={true}
              className={"component-section-container processing-time"}
              verticalAlign={"top"}
              textAlign={"center"}
              columns={"equal"}
            >
              <Grid.Row stretched={true}>
                <Grid.Column>
                  <Image
                    size={"small"}
                    centered={true}
                    src={
                      "https://fisherman.gumlet.io/public/honeydipfingerzllc/Untitled_design_2.png"
                    }
                  />
                  <h4>WORKING HOURS</h4>
                  <HoursOfOperation
                    hours={fishermanBusiness.primaryLocation.hours}
                    displayOption={"grouped"}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
          <Map
            address={{
              street: "",
              city: fishermanBusiness.primaryLocation.city,
              state: fishermanBusiness.primaryLocation.state,
              zip: fishermanBusiness.primaryLocation.zipCode,
            }}
          />
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        hours {
          day
          open
          close
          label
        }
        city
        state
        zipCode
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
      }
    }
  }
`;
